export const m = {
  loginToUnlockHeading: `Log in to unlock`,
  loginToUnlockNudge: `To download the rulebook, you must own Space\u00A0Gits and be logged in to Indie Tabletop Club.`,

  // TODO (Phase 4): Update these to mention smart rules.
  loginDescription: `Log into your Indie Tabletop Club account to unlock owned content and enable backup & sync.`,
  joinPromptDescription: `Enable backup & sync, unlock owned content, and more!`,
  accountJoinOrLoginNudge: `Not logged in. Join Indie Tabletop Club or log into your account to unlock your owned content and enable backup & sync!`,
};
